<div *ngIf="context &&  context.length >0" class="context-wrap">
    <div  *ngFor="let field of context"  [ngSwitch]="mode" class="field-{{field['solr_field']}} context-fields-wrap">
        <div *ngIf="item[field['solr_field']]" class="context-field-wrap">
            <div>
                <span class="value lh-base" [innerHTML]="replaceData(item[field['solr_field']]) | safe : 'html'" ></span>
            </div>
        </div>
    </div>
</div>
